export default __webpack_public_path__ + "static/media/palm-tree.65de471a.png";